import { render, staticRenderFns } from "./triviaQuestionData.vue?vue&type=template&id=3cfaa64f"
import script from "./triviaQuestionData.vue?vue&type=script&lang=js"
export * from "./triviaQuestionData.vue?vue&type=script&lang=js"
import style0 from "./triviaQuestionData.vue?vue&type=style&index=0&id=3cfaa64f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports